import { SupportedPlatforms } from '@smg-real-estate/domus';

const isServer = (): boolean => import.meta.env.SSR;

const isPlatformIs24 = (): boolean => import.meta.env.VUE_APP_PLATFORM === 'is24';
const isPlatformHg = (): boolean => import.meta.env.VUE_APP_PLATFORM === 'hg';
const getCurrentPlatformTheme = (): SupportedPlatforms =>
  isPlatformIs24() ? SupportedPlatforms.is24 : SupportedPlatforms.hg;

export { getCurrentPlatformTheme, isPlatformHg, isPlatformIs24, isServer };
